/**
 * lib/posthog/auth-recovery-flag.ts
 *
 * What it does:
 *   Sole read point for the `authRecoveryInterceptor` kill switch, for code
 *   that runs outside React (the axios interceptor in lib/utils, the global
 *   SWR onError in Providers.tsx, the visibilitychange handler in _app.js).
 *   Evaluation is a synchronous in-memory lookup against the flags posthog-js
 *   fetched at init — no network call per check.
 *
 * What it does NOT do:
 *   No flag-exposure analytics (send_event: false — this is a release kill
 *   switch, not an experiment). No opinion on what "enabled" means — callers
 *   own the behavior branch. Returns false during SSR and before the flags
 *   payload loads, so the safe default is always the legacy code path.
 *
 * Depends on:
 *   - posthog-js (singleton initialized in instrumentation-client.ts)
 *   - @/lib/posthog/feature-flags (flag key registry)
 */

import posthog from "posthog-js";

import { POSTHOG_FEATURE_FLAGS } from "@/lib/posthog/feature-flags";

export function isAuthRecoveryEnabled(): boolean {
  if (typeof window === "undefined") return false;
  return (
    posthog.isFeatureEnabled(POSTHOG_FEATURE_FLAGS.AUTH_RECOVERY_INTERCEPTOR, {
      send_event: false,
    }) === true
  );
}
